import React, { useEffect, useState } from 'react';
import useMediaQuery from '@/client/hooks/useMediaQuery';
import { Box } from '@hz-design-system/web-ui';
import { formatImageUrl } from '@ecg-marktplaats/media-util-js-lib';
import { MAIN_IMAGE_SIZE_XXL } from '@/client/constants/listings';
import { MainImageItemProps } from './types';
import ListingUrgencyBadge from '@/client/components/ListingsNew/components/ListingUrgencyBadge/ListingUrgencyBadge';
import ImageItem from './components/ListingImageItem';
import Classes from './ListingFigureMainImage.module.scss';

const MainImageItem: React.FC<MainImageItemProps> = ({
  image,
  loadingType,
  decodingType,
  fetchPriority,
  children,
  favoriteIconAriaLabel,
  onFavorite,
  isFavorite,
  descriptionElementId,
  urgencyFeatureActive,
  aspectRatio = 'landscape',
  showFavoriteIcon = false,
  enableLandscapeContain = false,
}) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const [imageSource, setImageSource] = useState(image.imageSource);

  useEffect(() => {
    if (isDesktop && image?.url) {
      setImageSource(formatImageUrl(image.url, MAIN_IMAGE_SIZE_XXL, image.sizes));
    } else {
      setImageSource(image.imageSource);
    }
  }, [isDesktop, image]);

  const imageWithSource = { ...image, imageSource };

  return (
    <ImageItem
      image={imageWithSource}
      kind="main"
      fetchPriority={fetchPriority}
      loadingType={loadingType}
      decodingType={decodingType}
      onFavorite={onFavorite}
      isFavorite={isFavorite}
      favoriteIconAriaLabel={favoriteIconAriaLabel}
      descriptionElementId={descriptionElementId}
      aspectRatio={aspectRatio}
      showFavoriteIcon={showFavoriteIcon}
      enableLandscapeContain={enableLandscapeContain}
    >
      {isDesktop && urgencyFeatureActive && (
        <Box as="div" name="Listing-urgency-badge" className={Classes['hz-Listing-urgency-badge']}>
          <ListingUrgencyBadge />
        </Box>
      )}
      {children}
    </ImageItem>
  );
};

export default MainImageItem;
